import { Checkbox, Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { NotificationClassroom } from '../../../types/notification';

export interface ClassroomCheckboxItemProps {
  readonly classroom: NotificationClassroom;
  readonly checked: boolean;
  readonly onToggle: (id: string, studentCount: number, name: string) => void;
}

export function ClassroomCheckboxItem({
  classroom,
  checked,
  onToggle,
}: ClassroomCheckboxItemProps) {
  const { t } = useTranslation('notification');

  return (
    // biome-ignore lint/a11y/useSemanticElements: card checkbox pattern — button mantém foco individual por Tab sem delegação ao input
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      className={[
        'flex w-full cursor-pointer items-center gap-mini px-xxs py-nano transition-colors',
        'border-b-hairline border-ctx-layout-border last:border-b-none hover:bg-ctx-layout-bg',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ctx-content-title',
        'border-b-hairline border-ctx-layout-border',
      ].join(' ')}
      onClick={() => onToggle(classroom.id, classroom.studentCount, classroom.name)}
    >
      <div className="flex min-w-none flex-1 overflow-hidden items-center gap-nano">
        <div aria-hidden className="pointer-events-none shrink-0">
          <Checkbox checked={checked} />
        </div>
        <span className="ts-caption-xxs truncate text-left text-ctx-content-title">
          {classroom.name}
        </span>
      </div>
      <div className="shrink-0">
        <Tag
          label={t('wizard.audience.studentsCount', {
            count: classroom.studentCount,
          })}
          size="sm"
          custom={{ text: 'text-nowrap' }}
        />
      </div>
    </button>
  );
}
